import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/grailed-seller-verification';

export default function Example() {
  return (
    <>
      <Head>
        <title>Grailed Seller's Profile Verification: Why It Matters and How To Do It</title>
        <meta
          name='description'
          content='Part of selling on marketplaces is gaining the trust of potential buyers–and doing this entails building up a great profile and relationship with customers.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/grailed-seller-verification' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/grailed-seller-verification' />
        <meta property='og:title' content="Grailed Seller's Profile Verification: Why It Matters and How To Do It" />
        <meta
          property='og:description'
          content='Part of selling on marketplaces is gaining the trust of potential buyers–and doing this entails building up a great profile and relationship with customers.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-05-15T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-05-15T00:00:00-00:00' />
        <meta property='article:tag' content='Grailed' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
